import { Resource } from "../resource";

export class ShippingMethod extends Resource {
    description: string;
    name:        string;
    price:       number;
}
